"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceClient = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const handleApiError_1 = tslib_1.__importDefault(require("./handleApiError"));
const removeEmptyKeys_1 = require("./removeEmptyKeys");
class ResourceClient {
    constructor(resourceName, options) {
        this.axiosInstance = axios_1.default.create(options);
        this.resourceName = resourceName;
    }
    static fromAxiosInstanceAndName(axiosInstance, resourceName) {
        const resourceClient = new this(resourceName);
        resourceClient.axiosInstance = axiosInstance;
        return resourceClient;
    }
    create(requestData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance.request({
                url: `/${this.resourceName}`,
                method: 'POST',
                data: requestData,
            });
            return response;
        });
    }
    update(id, requestData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance.request({
                url: `/${this.resourceName}/${id}`,
                method: 'PATCH',
                data: requestData,
            });
            return response;
        });
    }
    list(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            params = (0, removeEmptyKeys_1.removeEmptyKeys)(params);
            const response = yield this.axiosInstance.request({
                url: `/${this.resourceName}`,
                params,
            });
            return response;
        });
    }
    find(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance.request({
                url: `/${this.resourceName}/${id}`,
            });
            return response;
        });
    }
    delete(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.axiosInstance.request({
                method: 'DELETE',
                url: `/${this.resourceName}/${id}`,
            });
        });
    }
}
exports.ResourceClient = ResourceClient;
tslib_1.__decorate([
    handleApiError_1.default
], ResourceClient.prototype, "create", null);
tslib_1.__decorate([
    handleApiError_1.default
], ResourceClient.prototype, "update", null);
tslib_1.__decorate([
    handleApiError_1.default
], ResourceClient.prototype, "list", null);
tslib_1.__decorate([
    handleApiError_1.default
], ResourceClient.prototype, "find", null);
tslib_1.__decorate([
    handleApiError_1.default
], ResourceClient.prototype, "delete", null);
//# sourceMappingURL=ResourceClient.js.map